import { type CSSResultGroup, LitElement, unsafeCSS } from 'lit'
import { customElement } from 'lit/decorators.js'
import styles from './eco-suite-navbar-menu-divider.scss?inline'

/**
 * @summary A visual divider for separating groups of items within a navbar menu.
 * @tag eco-suite-navbar-menu-divider
 */
@customElement('eco-suite-navbar-menu-divider')
export class EcoSuiteNavbarMenuDivider extends LitElement {
  static readonly styles: CSSResultGroup = [unsafeCSS(styles)]

  connectedCallback() {
    super.connectedCallback()
    this.setAttribute('role', 'separator')
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'eco-suite-navbar-menu-divider': EcoSuiteNavbarMenuDivider
  }
}
